// extracted by mini-css-extract-plugin
export default {"container":"MyEditor_container__cEAV5","hidden":"MyEditor_hidden__hX8Kb","upload":"MyEditor_upload__vd2oO"};